function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { MarkdownEl } from "common/components/markdown";
import { ArrowType, DisplaySize } from "./types";
export function template() {
  var _this$lazyContentRend;
  const {
    visibility
  } = this.state;
  const imageUrl = this.attr("image-src");
  const {
    print
  } = this.getContext("i18n");
  const text = this.params.text ? print(this.params.text) : this.attr("text");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-tooltip", class: {
    "is-tooltip-tour": this.attr("is-tooltip-tour"),
    "is-dot-line-arrow": this.attr("arrow-type") === ArrowType.LineDot,
    "has-max-width": this.attr("max-width") !== null || this.attr("size") !== DisplaySize.Fit,
    "is-animated": this.helpers.shouldAnimateTooltip(),
    "has-image": !!imageUrl,
    ["is-".concat(visibility)]: true,
    ["size-".concat(this.attr("size"))]: true,
    "break-word": this.attr("break-word")
  }, style: _objectSpread(_objectSpread(_objectSpread({}, this.attr("max-width") && {
    "max-width": this.attr("max-width"),
    hyphens: "auto"
  }), this.attr("text-align") && {
    "text-align": this.attr("text-align")
  }), {}, {
    "--tooltip-offset": "".concat(this.helpers.getOffset(), "px")
  }), on: {
    click: this.helpers.stopPropagation,
    mousedown: this.helpers.stopPropagation,
    mouseleave: (ev) => this.hide(ev)
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, imageUrl && /* @__PURE__ */ jsx("img", { sel: ".mp-tooltip-image", attrs: {
    src: imageUrl
  } }), /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }), text && visibility !== this.helpers.VISIBILITY_HIDDEN && /* @__PURE__ */ jsx(MarkdownEl, { sel: ".mp-tooltip-text", attrs: {
    text: text.toString()
  } }), visibility !== this.helpers.VISIBILITY_HIDDEN && ((_this$lazyContentRend = this.lazyContentRenderer) === null || _this$lazyContentRend === void 0 ? void 0 : _this$lazyContentRend.call(this, this.getContext("i18n"))), this.attr("arrow-type") === ArrowType.Default && !this.attr("is-tooltip-tour") ? /* @__PURE__ */ jsx("div", { sel: ".mp-tooltip-arrow" }) : null);
}
